import React from 'react';
import PageLayout from '../../layout/PageLayout';
import './CancellationPolicy.css';

const CancellationPolicy = () => {
  return (
    <PageLayout>
      <div className="cancellation-policy-container">
        <h1 className="page-title">Cancellation and Refund Policy</h1>
        <p>
          Effective Date: <span className="policy-update-date">01-Apr-2026</span>
        </p>
        <p>
          At RuhiTech Solutions, we are committed to delivering high-quality
          software services and products. We understand that business needs can
          change, and this policy outlines the terms for cancellations and
          refunds applicable to our services and products. Please read this
          policy carefully before engaging with us.
        </p>

        <h2>1. Service Engagement Cancellations</h2>
        <p>
          Cancellation requests for service engagements must be submitted in
          writing to{' '}
          <a href="mailto:contact@ruhitechsolutions.com">contact@ruhitechsolutions.com</a>. The
          following terms apply:
        </p>
        <ul>
          <li>
            <strong>Before Project Commencement:</strong> If a cancellation is
            requested before any work has commenced, any advance or retainer
            paid will be refunded in full, less any administrative or
            consultation fees already incurred.
          </li>
          <li>
            <strong>After Project Commencement:</strong> If work has already
            begun, the client will be charged for all work completed up to the
            date of cancellation, calculated on a pro-rata basis or as per the
            agreed milestone structure. Any advance paid in excess of the work
            completed will be refunded.
          </li>
          <li>
            <strong>Mid-Project Cancellation:</strong> Where a project has
            reached or exceeded 50% completion, no refund will be applicable on
            the milestone payments made. The client will receive all deliverables
            completed up to the point of cancellation.
          </li>
        </ul>

        <h2>2. Refund Eligibility</h2>
        <ul>
          <li>
            <strong>Full Refund:</strong> Applicable only when cancellation is
            made before any work has started and within 48 hours of the initial
            payment.
          </li>
          <li>
            <strong>Partial Refund:</strong> Applicable when work has commenced
            but is less than 50% complete. The refund amount will be calculated
            based on the work remaining, minus any costs already incurred.
          </li>
          <li>
            <strong>No Refund:</strong> No refund will be issued once a project
            milestone has been delivered and approved by the client, or when the
            project is 50% or more complete.
          </li>
        </ul>

        <h2>3. Product Licence Cancellations</h2>
        <p>
          For proprietary software products offered by RuhiTech Solutions under
          a subscription or licence model:
        </p>
        <ul>
          <li>
            <strong>Monthly Subscriptions:</strong> May be cancelled at any time.
            The cancellation will take effect at the end of the current billing
            cycle. No refund will be provided for the remaining days in the
            current billing period.
          </li>
          <li>
            <strong>Annual Subscriptions:</strong> Cancellations made within 7
            days of the initial purchase date are eligible for a full refund.
            After 7 days, no refund will be provided for the remaining period of
            the annual subscription.
          </li>
          <li>
            <strong>Custom Product Licences:</strong> Cancellation and refund
            terms for custom or enterprise product licences will be governed by
            the specific licence agreement signed between the parties.
          </li>
        </ul>

        <h2>4. Cancellation by RuhiTech Solutions</h2>
        <p>
          RuhiTech Solutions reserves the right to cancel or suspend a service
          engagement or product licence under the following circumstances:
        </p>
        <ul>
          <li>Non-payment or overdue invoices beyond 30 days.</li>
          <li>Breach of the Terms and Conditions by the client.</li>
          <li>Circumstances beyond our reasonable control (force majeure).</li>
        </ul>
        <p>
          In the event of cancellation by RuhiTech Solutions without fault of
          the client, a proportional refund for undelivered work or unused
          subscription period will be provided.
        </p>

        <h2>5. Non-Refundable Items</h2>
        <p>The following are non-refundable under all circumstances:</p>
        <ul>
          <li>Consultation fees and discovery/scoping session charges.</li>
          <li>Third-party costs incurred on the client's behalf (domain registrations, hosting, API licences, etc.).</li>
          <li>Any work that has been delivered, reviewed, and approved by the client.</li>
          <li>Rush or priority processing fees.</li>
        </ul>

        <h2>6. Refund Processing</h2>
        <p>
          Approved refunds will be processed within 10–15 business days from
          the date of approval. Refunds will be credited to the original payment
          method used at the time of purchase. RuhiTech Solutions is not
          responsible for delays caused by banking institutions or payment
          processors.
        </p>

        <h2>7. Dispute Resolution</h2>
        <p>
          In the event of a dispute regarding a cancellation or refund, both
          parties agree to attempt resolution through good-faith negotiation
          first. If an agreement cannot be reached, the matter shall be referred
          to mediation or arbitration before any legal proceedings are initiated.
        </p>

        <h2>8. Changes to This Policy</h2>
        <p>
          RuhiTech Solutions reserves the right to modify this Cancellation and
          Refund Policy at any time. Changes will be published on this page with
          an updated effective date. Continued engagement with our services or
          products after changes are posted constitutes acceptance of the revised
          policy.
        </p>

        <h2>9. Governing Law</h2>
        <p>
          This policy shall be governed by and construed in accordance with the
          laws of India. Any disputes arising from this policy shall be subject
          to the exclusive jurisdiction of the competent courts in Chennai, Tamil
          Nadu.
        </p>

        <h2>Contact Information</h2>
        <p>
          For cancellation requests or refund enquiries, please contact us:
        </p>
        <ul>
          <li>
            Email:{' '}
            <a href="mailto:contact@ruhitechsolutions.com">contact@ruhitechsolutions.com</a>
          </li>
          <li>Phone: +91 8220343006</li>
          <li>
            Address: #140, 1st Floor, Plaza Center, No 129, G.N. Chettey Road,
            Chennai - 600006
          </li>
        </ul>
      </div>
    </PageLayout>
  );
};

export default CancellationPolicy;
